/**
 * @module canvas.constants
 * Constants for canvas-based texture generation (BatteryMesh, ParkingMarker).
 */

/** Pixels per foot for device label textures. */
export const LABEL_PX_PER_FOOT = 32;

/** Minimum canvas width in pixels for device labels. */
export const LABEL_MIN_WIDTH = 512;

/** Minimum canvas height in pixels for device labels. */
export const LABEL_MIN_HEIGHT = 256;

/** Spacing in feet between structural panel divisions on battery meshes. */
export const PANEL_SPACING_FT = 5;

/** Canvas dimensions in pixels for the parking "P" texture. */
export const PARKING_CANVAS_SIZE = 256;

/** Background opacity for device label backing. */
export const LABEL_BG_OPACITY = 0.7;

/** Background opacity for parking marker backing. */
export const PARKING_BG_OPACITY = 0.6;

/** Corner radius in pixels for the device label rounded rect. */
export const LABEL_CORNER_RADIUS = 20;
